// Mirrors the API's constants/MissionType.ts. No shared package exists, so keep the two in sync by hand.
export const MISSION_TYPES = {
  FIRST_ORDER: "FIRST_ORDER",
  ORDER_COUNT_MILESTONE: "ORDER_COUNT_MILESTONE",
  MONTHLY_SPEND: "MONTHLY_SPEND",
  COURIER_ORDER_COUNT: "COURIER_ORDER_COUNT",
  COURIER_SPEND: "COURIER_SPEND",
};

// The one list of type options, shared by the create form, the edit modal and the filter bar.
export const MISSION_TYPE_OPTIONS = [
  { value: MISSION_TYPES.FIRST_ORDER, label: "First completed order" },
  { value: MISSION_TYPES.ORDER_COUNT_MILESTONE, label: "Nth completed orders milestone" },
  { value: MISSION_TYPES.MONTHLY_SPEND, label: "Monthly spend milestone" },
  { value: MISSION_TYPES.COURIER_ORDER_COUNT, label: "Single-courier completed orders milestone" },
  { value: MISSION_TYPES.COURIER_SPEND, label: "Single-courier spend milestone" },
];

// Missions scoped to one courier. The API requires a courier and a date range on these, and locks
// both the type and the courier once the mission exists.
export const COURIER_MISSION_TYPES = [
  MISSION_TYPES.COURIER_ORDER_COUNT,
  MISSION_TYPES.COURIER_SPEND,
];

export const isCourierMissionType = (type) => COURIER_MISSION_TYPES.includes(type);
